import { z } from 'zod';

// TODO: Add more validation rules or types like under 65, over 65, etc.
export const DateOfBirth = z.date();

export type DateOfBirth = z.infer<typeof DateOfBirth>;
